/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetIncomingActionsForResourceQuery,
  FutureActionsForResourceSortInput,
  FutureActionsForResourceFilterInput,
  PastActionsForResourceSortFields,
} from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  resourceId: string;
  page: string;
  limit: string;
  sort?: FutureActionsForResourceSortInput | PastActionsForResourceSortFields;
  filter?: FutureActionsForResourceFilterInput;
  skip?: boolean;
};

export function useGetIncomingActionsForResource({
  resourceId,
  page,
  limit,
  sort,
  filter,
  skip,
}: Props) {
  const {
    data: result,
    loading,
    error,
  } = useGetIncomingActionsForResourceQuery({
    variables: {
      resourceId,
      page: Number(page),
      limit: Number(limit),
      sort: sort as FutureActionsForResourceSortInput,
      filter,
    },
    onError(err) {
      showError(err.message);
    },
    skip,
  });

  const data = result?.futureActionsForResource?.result ?? [];
  const count = result?.futureActionsForResource.pageInfo.count ?? 0;

  return { data, loading, count, error } as const;
}
